import { useContext } from 'react';
import { FeesContext } from 'src/context/fees-context';
import { SalesforceContext, AcquiringChannelFlags } from 'src/context/salesforce-context';
import { vatPercent } from 'src/helpers/constants';

const compareNumbers = (a, b) => a - b;

export const GetMinMaxCardFees = (terminalID) => {
  const { getFilteredCardFees } = useContext(FeesContext);
  const { uniqueTerminals, isUseFixedCardFeesForDisplay } = useContext(SalesforceContext);

  const terminal = uniqueTerminals[terminalID];
  const isCardPresentStatus = terminal.card_present ? 'Card Present' : 'Card Not Present';
  const cardFees = getFilteredCardFees(isUseFixedCardFeesForDisplay(terminalID));
  const applicableCardFees = (cardFees || []).filter(
    (cardFee) => cardFee.feeCategoryName === isCardPresentStatus,
  );
  const numericFeeList = applicableCardFees
    .map((cardFee) => cardFee.percentage)
    .sort(compareNumbers);
  return [numericFeeList[0], numericFeeList[numericFeeList.length - 1]];
};

export const getAcquiringChannels = (deliveries) =>
  Object.values(deliveries).map((delivery) =>
    delivery.number_of_devices > 0 ? delivery.acquiring_channel : '',
  );

export const getOnceOffTotal = (deliveries) =>
  Object.values(deliveries)
    .map((delivery) => {
      const priceExclVAT =
        delivery.acquiring_channel === AcquiringChannelFlags.buyOnlineFicaOnline
          ? delivery.price * delivery.number_of_devices
          : 0;
      const VAT = priceExclVAT * vatPercent;
      return priceExclVAT + VAT;
    })
    .reduce((a, b) => a + b, 0);

export const getMonthlyTotal = (deliveries) =>
  Object.values(deliveries)
    .map((delivery) => {
      const priceExclVAT =
        delivery.acquiring_channel === AcquiringChannelFlags.rentOnlineFicaOnline ||
        delivery.acquiring_channel === AcquiringChannelFlags.zeroRentOnlineFicaOnline
          ? delivery.price * delivery.number_of_devices
          : 0;
      const VAT = priceExclVAT * vatPercent;
      return priceExclVAT + VAT;
    })
    .reduce((a, b) => a + b, 0);
